import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { afterSalesApi } from '../..'
import { GetCmResponsibleResponse } from './getCmResponsible.types'

export const getCmResponsible = async () => {
  const response = await afterSalesApi.get<GetCmResponsibleResponse>(
    '/api/external/cm-responsible'
  )

  return response.data.data
}

export const GET_CM_RESPONSIBLE_QUERY_KEY = 'getCmResponsible'

export const useGetCmResponsibleQuery = (
  options?: ExtendableQueryOptions<GetCmResponsibleResponse['data']>
) => {
  return useQuery({
    queryKey: [GET_CM_RESPONSIBLE_QUERY_KEY],
    queryFn: getCmResponsible,
    ...options
  })
}
